import { render, staticRenderFns } from "./TabelaCadastros.vue?vue&type=template&id=2964b7c8&scoped=true"
import script from "./TabelaCadastros.vue?vue&type=script&lang=js"
export * from "./TabelaCadastros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2964b7c8",
  null
  
)

export default component.exports